<template lang="html">
	<div>
		<div class="text-lg font-medium">
			Connection quality
		</div>
		<div class="text-gray-500 dark:text-gray-300">
			Gauge how good your internet connection is for this session
		</div>
		<div class="flex mt-4">
			<div class="w-2/3">
				<!-- <connection-quality-chart :chartData="chartData" class="h-32"></connection-quality-chart> -->
			</div>
			<div class="w-1/3 font-medium text-right">
					<div class="text-gray-600 dark:text-gray-400">
						Average upload
					</div>
					<div class="text-3xl flex items-end justify-end space-x-2">
						<div id="uploadSpeed" class="flex space-x-1 mt-2" :data-tippy-content="averageUploadSpeed">
							<div class="w-4 h-4 rounded-full bg-blue-500 dark:bg-blue-300" v-for="dots in uploadSpeedDots"></div>
							<div class="w-4 h-4 rounded-full bg-gray-300 dark:bg-gray-600" v-for="dots in (5 - uploadSpeedDots)"></div>
						</div>
					</div>
					<div class="text-gray-600 dark:text-gray-400 mt-2">
						Average download
					</div>
					<div class="text-3xl flex items-end justify-end space-x-2">
						<div class="flex space-x-1 mt-2" :data-tippy-content="averageDownloadSpeed">
							<div class="w-4 h-4 rounded-full bg-blue-500 dark:bg-blue-300" v-for="dots in downloadSpeedDots"></div>
							<div class="w-4 h-4 rounded-full bg-gray-300 dark:bg-gray-600" v-for="dots in (5 - downloadSpeedDots)"></div>
						</div>
					</div>
			</div>
		</div>
	</div>
</template>
<script>
import { detectBrowser } from 'utils/browser';
// import ConnectionQualityChart from './connection-quality-chart'

export default {
	// components: { ConnectionQualityChart },
	data() {
		return {
			downloadSpeeds: [],
			uploadSpeeds: [],
			graphedDownloadSpeeds: [],
			graphedUploadSpeeds: [],

			DEFAULT_OPTIONS: {
				uploadUrl: "/test_upload",
				uploadDataSize: 2 * 1024 * 1024, // 2 Megabits
				uploadDataMaxSize: Number.MAX_VALUE
			}
		}
	},
	mounted() {
	  window.setTimeout(()=>{
		this.testUpload()
		this.testDownload()
	  }, 5000)

		window.setInterval(()=>{
			this.testUpload()
		}, 1000 * 60)

		this.graphedDownloadSpeeds.push(0)
		this.graphedUploadSpeeds.push(0)
		window.setInterval(()=>{
			// get last download speed and push it to the graph
			this.graphedDownloadSpeeds.push(this.downloadSpeedDots)
			this.graphedUploadSpeeds.push(this.uploadSpeedDots)
		}, 1000 * 30)
	},
	methods: {
		testUpload(){
			if(detectBrowser(window).browser != 'chrome' || detectBrowser(window).version < 81) return;
			this.testUploadSpeed(this.DEFAULT_OPTIONS, authenticity_token).then( res => {
				let uploadSpeedInMbps = res.uploadSpeed / 1024 / 1024
				window.uploadSpeed = uploadSpeedInMbps.toFixed(2)
				this.uploadSpeeds.push(parseFloat(window.uploadSpeed))
				if (manager) manager.sendSessionInfo()
			})
		},
		testDownload(){
			this.getDownloadSpeed()
		},
		/**
		* Calculates the bandwidth in bps (bits per second)
		* @param size the size in bytes to be transfered
		* @param startTime the time when the transfer started. The end time is
		* considered to be now.
		*/
		calculateBandwidth(size, start) {
			return (size * 8) / ((new Date().getTime() - start) / 1000);
		},
		truncate(data, maxSize) {
			if (maxSize === undefined) {
			return;
			}
			if (data.length > maxSize) {
			if (data.substring) {
				data = data.substring(0, maxSize);
			} else {
				data.length = maxSize;
			}
			}
			return data;
		},
  		testUploadSpeed(options, token) {

				var self = this;
			return new Promise(function (resolve, reject) {
				// generate randomly the upload data
				if (!options.uploadData) {
				options.uploadData = new Array(Math.min(options.uploadDataSize, options.uploadDataMaxSize));
				for (var i = 0; i < options.uploadData.length; i++) {
					options.uploadData[i] = Math.floor(Math.random() * 256);
				}
				} else {
				options.uploadData = self.truncate(options.uploadData, options.uploadDataMaxSize);
				}

				var start = new Date().getTime();
				var fd = new FormData();

				fd.append( 'file',  new Blob(options.uploadData, {type: 'application/octet-binary'})  , 'test-upload.wav');
				fd.append('authenticity_token', token)

				var req = new XMLHttpRequest();
				req.open('POST', options.uploadUrl + "?id=" + start);


				req.onreadystatechange = function (aEvt) {
				if (req.readyState == 4) {
					if(req.status == 200)
					resolve ({ uploadSpeed: self.calculateBandwidth(options.uploadData.length, start) } );
					else
					reject(this.status)
				}
				};
				//req.setRequestHeader('Content-type',  'application/octet-stream');
				req.send(fd);
					// dataType: 'application/octet-stream',
			});
		},
		// get download speed by the Chrome API
		getDownloadSpeed(){
			if (!navigator.connection) return;
			let downloadSpeedInMbps = navigator.connection.downlink
			this.downloadSpeeds.push(downloadSpeedInMbps);
			var that = this;
			navigator.connection.onchange = (e) => {
				window.downloadSpeed = e.target.downlink;
				that.downloadSpeeds.push(downloadSpeedInMbps);
				if (manager) manager.sendSessionInfo()
			}
		},
		// unusued function
 		downloadSampleFile(){
			// Taken From
			// https://gist.github.com/debloper/7296289
			// Let's initialize the primitives
			var startTime, endTime, fileSize;

			// Set up the AJAX to perform
			var xhr = new XMLHttpRequest();

			// Rig the call-back... THE important part
			xhr.onreadystatechange = function () {

				// we only need to know when the request has completed
				if (xhr.readyState === 4 && xhr.status === 200) {

				// Here we stop the timer & register end time
				endTime = (new Date()).getTime();

				// Also, calculate the file-size which has transferred
				fileSize = xhr.responseText.length;

				// Calculate the connection-speed
				var speed = (fileSize * 8) / ((endTime - startTime)/1000) / 1024;

				// Report the result, or have fries with it...
				console.log(speed + " Kbps\n");
				}
			}

			// Snap back; here's where we start the timer
			startTime = (new Date()).getTime();

			// All set, let's hit it!
			xhr.open("GET", "URL/TO/PROBE.FILE", true);
			xhr.send();
		},
	},
	computed: {
		downloadSpeedDots(){
			let dots = 0;
			if (this.averageDownloadSpeed > 2) dots += 1
			if (this.averageDownloadSpeed > 5) dots += 1
			if (this.averageDownloadSpeed > 8) dots += 1
			if (this.averageDownloadSpeed > 10) dots += 1
			return dots
		},
		uploadSpeedDots(){
			let dots = 0;
			if (this.averageUploadSpeed > 2) dots += 1
			if (this.averageUploadSpeed > 5) dots += 1
			if (this.averageUploadSpeed > 8) dots += 1
			if (this.averageUploadSpeed > 10) dots += 1
			return dots
		},
		chartData(){
			let labels = [];
			for (var i = 1; i <= this.graphedUploadSpeeds.length; i++) {
				labels.push(i);
			}
			return {
				labels: labels,
				datasets: [
					{
					label: 'Upload speed',
					backgroundColor: 'hsla(238, 100%, 93%, 0.5)',
					borderColor: 'hsla(238, 100%, 93%, 0.5)',
					pointRadius: 0,
					data: this.graphedUploadSpeeds
					},
					{
					label: 'Download speed',
					backgroundColor: 'hsla(359, 74%, 68%, 0.5)',
					borderColor: 'hsla(359, 74%, 68%, 0.5)',
					pointRadius: 0,
					data: this.graphedDownloadSpeeds
					},
				]
			}
		},
		averageUploadSpeed(){
			// Taken from https://stackoverflow.com/a/62372003/7162686
			if (this.uploadSpeeds.length === 0) return 0
			return this.uploadSpeeds.reduce((a,v,i)=>(a*i+v)/(i+1)).toFixed(2);
		},
		averageDownloadSpeed(){
			if (this.downloadSpeeds.length === 0) return 0
			// Taken from https://stackoverflow.com/a/62372003/7162686
			return this.downloadSpeeds.reduce((a,v,i)=>(a*i+v)/(i+1)).toFixed(2)
		}
	}

}
</script>
<style lang="">

</style>
